"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var reinitializeState = function reinitializeState(state, initialState, config) {
  if (!config.excludes) return initialState;
  return Object.keys(initialState).reduce(function (resetState, currentStateKey) {
    if (!config.excludes.includes(currentStateKey)) {
      resetState[currentStateKey] = initialState[currentStateKey];
    } else {
      resetState[currentStateKey] = state[currentStateKey];
    }

    return resetState;
  }, {});
};

var _default = reinitializeState;
exports["default"] = _default;